import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkMuteRemoteVideo } from 'features/streaming/actions';

export function* bulkMuteRemoteVideoSaga({ payload }: ReturnType<typeof bulkMuteRemoteVideo>) {
  logger
    .remote({ action: true })
    .log('Bulk mute remote video requested', { roles: payload?.roles });

  yield call(SignalingSocket.send, {
    event: 'bulkMuteRemoteVideo',
    ...(payload && { data: { roles: payload.roles } }),
  });
}
